import apiClient from "../apiClient";

const resource = "attendanceReports";

export default {
    getMonthly: params => apiClient.get(`${resource}/Monthly?${params}`),
    getEmployee: params => apiClient.get(`${resource}/Employee?${params}`),
    getDaily: (params, background = false) => apiClient.get(`attendance/daily?${params}`, { background }),
};
